/* global TruTranslations */
/* global formatCurrency */
/* global Segment */

export class CheckoutBuild {
  constructor(build, maxPoints, overflowPoints, pointScale, addon, allWords, thresholds=[]) {
    // input all parameters
    this.maxPoints = maxPoints;
    this.overflowPoints = overflowPoints;
    this.maxOverflowPoints = this.maxPoints + this.overflowPoints
    this.pointScale = pointScale;
    this.addon = addon;
    this.allWords = allWords;
    this.thresholds = thresholds;
    this.products = [];
    this.boxInfoOpen = false;

    // initialize the filter variable
    this.filter = { category: "", search: "", local_toggle: "" };

    // for hiding while box is being displayed
    this.productSelectionElement = build.getElementsByClassName("build__selection")[0];

    // redundant for the document, but necessary for toggling between selection and box
    this.productSelectionElement.style.display = "block";

    // searchInput and no-results elements
    this.searchInputElement = document.getElementsByClassName("search-input")[0];
    this.noResultsElement = document.getElementsByClassName("no-results")[0];
    this.searchTermTextElement = document.getElementsByClassName("search-text")[0];
    this.suggestedSearchElement = document.getElementsByClassName("no-results-suggestion")[0];
    if (this.suggestedSearchElement)
      this.suggestSearchStringElement = this.suggestedSearchElement.getElementsByClassName("suggested-search-text")[0];
    this.mobileFilterButton = document.querySelector(".mobile-filter");

    // 'selection' elements and the 'all' element
    this.filterSelectionElements = build.getElementsByClassName("selection");
    this.noFilterSelectionElement = build.getElementsByClassName("all")[0];

    // all 'product' elements
    this.productElements = build.getElementsByClassName("product");

    // initialize boxed product dictionary that holds all added items information
    this.boxedProducts = {};
    this.boxContentElement = build.getElementsByClassName("box-info-products")[0];

    // points and progress bar elements
    this.currentPoints = 0.0;

    this.pointsCounterElements =
      document.getElementsByClassName("points-count"); //Changed scope to document, to grab header

    this.overflowPointsCounterElements = build.getElementsByClassName("overflow-points-count")

    this.progressBar = build.querySelector(".next-button .progress-bar");
    this.nextButton = build.getElementsByClassName("next-button")[0];

    this.overflowProgressBar = build.querySelector(".overflow-button .overflow-progress-bar");
    this.overflowButton = build.getElementsByClassName("overflow-button")[0];

    this.buildForm = document.getElementById("buildForm");

    this.boxInfo = document.querySelector(".box-items");
    this.boxInfoInner = document.querySelector(".box-items .inner");
    this.headerPointsCounter = document.querySelector(
      ".header__points-counter",
    );

    // trigger warning if exiting without saving
    this.isBoxAltered = false;
    this.submitTriggered = false;

    // tooltip elements (and hide tooltip on any clicks)
    this.tooltip = build.querySelector(".tooltip");
    this.tooltipText = this.tooltip.querySelector(".tooltip-text")
    document.getElementsByTagName("body")[0].addEventListener("click", () =>
      this.tooltip.classList.remove("show-tooltip"));

    // Overflow points modal
    this.overflowModalShown = false;
    this.overflowModal = document.getElementById('overflow-point-modal');

    window.onbeforeunload = (e) => {
      if (this.isBoxAltered && !this.submitTriggered) {
        e.preventDefault();
      }
    };

    this.updateElements();

    // Checks to see if mobileFilterButton exists on the DOM
    if (this.mobileFilterButton) {
      this.mobileFilterButton.addEventListener("click", () => this.showMobileFilter());
    }

    this.headerPointsCounter.addEventListener("click", e => this.toggleBoxInfo(e));
    this.boxInfo.addEventListener("click", e => this.toggleBoxInfo(e));
    document.addEventListener("click", e => {
      if (this.boxInfo.classList.contains("active") && !this.boxInfo.contains(e.target))
        this.toggleBoxInfo(e);
    });
  }

  toggleBoxInfo(evt) {
    if(!evt.target || this.boxInfoInner.contains(evt.target)){
      return
    }
    evt.stopPropagation();
    this.boxInfo.classList.toggle("active");
  }

  boxAltered() {
    if (!this.isBoxAltered) {
      this.isBoxAltered = true;
      this.submitTriggered = false;
    }
    return true;
  }

  /* item-selection _start_ */
  setSearchFilter(e) {
    // update and apply filter, each search term is space separated
    this.filter["search"] = e.value.trim().toLowerCase().split(" ");
    this.applyFilter();
  }

  // clear only the Search filter
  clearSearchFilter() {
    this.searchInputElement.value = this.filter["search"] = "";
    this.applyFilter();
  }

  setCategoryFilter(e, category) {
    // unselecting is the same as selecting 'ALL'
    if (e.classList.contains("selected")) return this.clearCategoryFilter();
    this.clearSearchFilter()
    // ensure the correct selection is emboldened
    this.unselectAll();
    e.classList.add("selected");

    // update and apply filter
    this.filter["category"] = category;
    this.applyFilter();
    this.showMobileFilter()
  }

  clearCategoryFilter() {
    // 'ALL' already selected
    if (this.noFilterSelectionElement.classList.contains("selected")) return;

    // unselect all filterSelectionElements
    this.unselectAll();
    this.noFilterSelectionElement.classList.add("selected");

    //Remove any text in the search box
    this.clearSearchFilter()

    // select the 'ALL' selection element, update filter and apply it
    this.filter["category"] = "";
    this.applyFilter();
  }

  setLocalFilter(localToggle) {
    this.filter["local_toggle"] = localToggle ? "true" : "false";
    this.applyFilter();
  }

  unselectAll() {
    for (let e of this.filterSelectionElements) {
      e.classList.remove("selected");
    }
  }

  applyFilter() {
    let results = false;
    let searchTerms = this.filter["search"];
    if (this.applyFilters(searchTerms, false)) {
      // there are results after applying the filter
      this.noResultsElement.style.display = "none";
      return;
    }

    // if there are no results, show the no results element (and populate it)
    this.noResultsElement.style.display = "block";
    this.suggestedSearchElement.style.display = "none";
    this.searchTermTextElement.innerHTML = this.getSearchTermText(searchTerms);

    // look for suggested words
    let suggestedWords = this.getSuggestedWords(searchTerms);
    if (suggestedWords) {
      // try searching for the suggested words and category filter
      results = this.applyFilters(suggestedWords, false);

      // if no results from previous search and there is a category applied: try searching for the suggested words only
      if (!results && this.filter["category"]) {
        results = this.applyFilters(suggestedWords, true);
      }

      if (results) {
        this.suggestSearchStringElement.innerHTML = suggestedWords.join(" ");
        this.suggestedSearchElement.style.display = "block";
        return;
      }
    } else if (this.filter["category"]) {
      // search by search terms only (remove category filter)
      if (this.applyFilters(searchTerms, true)) return;
    }

    // remove search terms, only apply category filter
    if (searchTerms.length && this.applyFilters([], false)) {
      this.suggestSearchStringElement.innerHTML = "";
      this.suggestedSearchElement.style.display = "none";
      return;
    }

    // all searches failed, just show all products
    for (let e of this.productElements) {
      e.style.display = "block";
    }
  }

  applyFilters(searchTerms, ignoreCategory) {
    let results = false;
    let localFilter = this.filter["local_toggle"] === "true";
    for (let e of this.productElements) {
      // filter by category, then by search terms
      if (
        (ignoreCategory || this.productMatchesCategory(e)) &&
        this.productMatchesSearchTerms(e, searchTerms) &&
        (!localFilter || e.dataset.is_local === "True")
      ) {
        // show product and update results to true
        e.style.display = "block";
        results = true;
      } else {
        e.style.display = "none";
      }
    }

    return results;
  }

  productMatchesCategory(p) {
    return !this.filter["category"] || p.dataset.categories.split(",").includes(this.filter["category"]);
  }

  productMatchesSearchTerms(p, searchTerms) {
    for (let term of searchTerms) {
      // filter by points if it's a number (1-5), the number must match the 'points' field
      if (/^\d{1,2}(\.25|\.5|\.75)?$/.test(term)) {
        if (p.dataset.points != term) return false;
      // filter by term (checking name and category)
      } else if (
        !p.dataset.name.includes(term) &&
        !p.dataset.categories.includes(term)
      ) {
        return false;
      }
    }
    return true;
  }

  getSearchTermText(searchTerms) {
    let text;
    if (this.filter["category"]) {
      text = this.filter["category"];
      if (searchTerms.length) {
        text += '" + "' + this.searchInputElement.value;
      }
    } else if (searchTerms.length) {
      text = this.searchInputElement.value;
    }
    return text;
  }

  getSuggestedWords(searchTerms) {
    let hasSuggestions = false;
    let suggestedWords = [];
    for (let word of searchTerms) {
      let suggestedWord = this.autoCorrect(word);
      if (suggestedWord != word) {
        hasSuggestions = true;
        suggestedWords.push(suggestedWord);
      } else {
        suggestedWords.push(word);
      }
    }

    return hasSuggestions ? suggestedWords : null;
  }

  autoCorrect(word, similarityThreshold = 0.25) {
    let maxSimilarity = 0;
    let mostSimilar = word;

    for (let w of this.allWords) {
      let similarity = this.getSimilarity(w, word);
      if (similarity > maxSimilarity) {
        maxSimilarity = similarity;
        mostSimilar = w;
      }
    }

    return maxSimilarity > similarityThreshold ? mostSimilar : word;
  }

  getSimilarity(word1, word2) {
    const bigram1 = this.getBigram(word1);
    const bigram2 = this.getBigram(word2);
    let similar = [];

    for (let c of bigram1) {
      if (bigram2.indexOf(c) > -1) similar.push(c);
    }

    return similar.length / Math.max(bigram1.length, bigram2.length);
  }

  getBigram(word) {
    let result = [];
    for (let i = 0; i < word.length - 1; i++) {
      result.push(word[i] + word[i + 1]);
    }
    return result;
  }
  /* item-selection _end_ */

  /* box-content _start_ */
  addToBox(event, id, superbutton=false) {
    let product = this.getProduct(id);
    if (!product) return;

    // parent button ignored once an item is added
    if (product.quantity && superbutton) return;

    // bonus products
    if (!product.pointValue) return;

    let pv = parseInt(product.pointValue);
    let new_total_points = this.currentPoints + pv;

    // check if the box is too full (this doesn't happen on new design)
    if (new_total_points > this.maxOverflowPoints) {
      this.showToolTip(true);
      if (event) event.stopPropagation()
      return;
    }

    if (event && !this.addon && this.maxPoints && new_total_points >= this.maxPoints) this.showOverflowModal();

    // update current points and propagate points change to elements
    this.currentPoints = new_total_points;
    product.quantity++;
    this.boxAltered();

    // increment quantity if it is already on the list
    let p = this.boxedProducts[product.id];
    if (p) {
      p["quantity"]++;
      this.validateProducts();
      p.element.element.querySelector(".points").innerHTML = this.getPointsFormatted(product);
      return;
    }

    // add box item to the DOM
    let boxItem = this.addBoxItem(product);
    boxItem.element.querySelector(".points").innerHTML = this.getPointsFormatted(product);
    try {
      if (event) Segment.productAddedToBox({product_id: product.id});
    } catch (e) {
      // meh - customer may be using an addblocker
    }

    // add to boxedProducts list (tracked by id)
    this.boxedProducts[id] = {
      name: product.name,
      pointValue: pv,
      summation: product.summation,
      quantity: 1,
      element: boxItem,
      price: parseFloat(product.price.replace(",", ".")),
    };
    this.validateProducts();
  }

  showToolTip(isFull) {
    this.tooltip.classList.add("show-tooltip");
    this.tooltipText.innerHTML = isFull
      ? TruTranslations["build_box_full_msg"]
      : TruTranslations["build_add_more"];
  }

  showOverflowModal() {
    if(!this.overflowModalShown){
      this.overflowModal.style.display = 'flex';
      this.overflowModalShown = true;
    }
  }

  removeFromBox(e, id) {
    let product = this.getProduct(id);
    if (!product.quantity) return;

    // bonus products cannot be removed here
    if (!product.pointValue) return;
    e.stopPropagation();

    // not in box checks
    let p = this.boxedProducts[product.id];
    if (!p) {
      console.error(`Product[${id}] quantity[${product.quantity}] not found in box: ` + this.boxedProducts);
      product.quantity = 0;
      this.validateProducts();
      return;
    }

    // update current points and propagate points change to elements
    this.currentPoints -= this.maxPoints ? p["pointValue"] : p["price"];
    if (this.currentPoints < 0) {
      console.error("removeFromBox - currentPoints: " + this.currentPoints);
      this.currentPoints = 0;
    }

    this.boxAltered();

    try {
      Segment.productRemovedFromBox({ product_id: id });
    } catch (e) {
      // meh, customer may be running an addblocker
    }

    // update or remove box item element
    product.quantity = --p["quantity"];
    if (product.quantity > 0) {
      p.element.element.querySelector(".points").innerHTML = this.getPointsFormatted(product);
    } else {
      p.element.element.remove();
      delete this.boxedProducts[id];
    }
    this.validateProducts();
  }

  updateElements() {
    // update the point counter
    if (this.addon && this.currentPoints === 0) {
      document.getElementsByClassName('addon_next')[0].style.display = 'none';
    } else if (this.addon) {
      document.getElementsByClassName('addon_next')[0].style.display = 'inline';
    }
    let innerHTML = "" + (this.addon ? this.currentPoints : this.currentPoints / this.pointScale);
    for (let e of this.pointsCounterElements) {
      e.innerHTML = innerHTML;
    }

    // update the total points in the box
    this.boxInfo.querySelector('.total-points-value').textContent =
        `${this.currentPoints / this.pointScale}/${this.maxPoints / this.pointScale}`;

    if (this.currentPoints <= this.maxPoints) {
      // update the total points in the box
      this.boxInfo.querySelector('.total-points-value').textContent =
        `${this.currentPoints / this.pointScale}/${this.maxPoints / this.pointScale}`;

      // update overflow points in the box
      this.boxInfo.querySelector('.overflow-total-points-value').textContent =
        `0/${this.overflowPoints / this.pointScale}`;

      for (let e of this.overflowPointsCounterElements) {
        e.innerHTML = "0";
      }
    } else {
      // update the total points in the box
      this.boxInfo.querySelector('.total-points-value').textContent =
        `${this.maxPoints / this.pointScale}/${this.maxPoints / this.pointScale}`;

      // update the overflow points in the box
      this.boxInfo.querySelector('.overflow-total-points-value').textContent =
        `${(this.currentPoints - this.maxPoints)/ this.pointScale}/${this.overflowPoints / this.pointScale}`;

      // update the overflow point counter
      innerHTML = "" + (this.addon ? this.currentPoints : (this.currentPoints - this.maxPoints) / this.pointScale);
      for (let e of this.overflowPointsCounterElements) e.innerHTML = innerHTML;
    }

    if (this.currentPoints < this.maxPoints && !this.addon) {
      this.overflowButton.style.display = 'none';
      this.boxInfo.querySelector('.max-points').style.display = 'none';
    }

    let threshold = this.thresholds.length ? this.thresholds[0] : this.maxPoints;
    this.updateProgressBarElements(threshold);

    this.updateOverflowProgressBarElement();

    // turn the checkout button green/gray
    this.updateCheckoutButton(threshold);

    if (!this.maxPoints) this.updateHeadingAndFooterElements();

    // check if we should present the overflow button
    if (!this.addon && this.maxPoints && this.currentPoints >= this.maxPoints) {
      this.overflowButton.style.display = 'block';
      this.boxInfo.querySelector('.max-points').style.display = 'block';
    }
  }

  updateProgressBarElements() {
    this.progressBar.style.width = `${(this.currentPoints / this.maxPoints) * 100}%`;
  }

  updateOverflowProgressBarElement() {
    if (this.addon) return;

    this.overflowProgressBar.style.width = `${((this.currentPoints - this.maxPoints) / this.overflowPoints) * 100}%`
  }

  updateHeadingAndFooterElements() {
    let hide = "display: none;",
      show = "display: block;",
      show_flex = "display: flex;";
    let t;
    if (this.currentPoints < this.thresholds[0]) t = 1;
    else t = this.currentPoints < this.thresholds[1] ? 2 : 3;

    // hide/show heading and footer text based on current threshold
    for (let i = 1; i <= 3; i++)
      for (let e of document.getElementsByClassName("alacarte-threshold-" + i))
        e.style = i == t ? show : hide;

    document.getElementById("alacarte-footer-text").style =
      t == 1 ? hide : show_flex;
    document.querySelector(".build__box .banner").style =
      t == 2 ? show_flex : hide;
    document.getElementById("footer-message-buffer").style =
      t == 1 ? hide : show;
    document.querySelector(".next-button .label").innerHTML =
      t == 1
        ? TruTranslations["alacarte_heading_1"]
        : TruTranslations["checkout"];

    if (t != 2) return;
    // update the 'dollars-to-go' element to accurately reflect the state
    let amount = formatCurrency(this.thresholds[1] - this.currentPoints);
    for (let e of document.getElementsByClassName("dollars-to-go"))
      e.innerHTML = TruTranslations["alacarte_amount_remaining"].replace(
        "{}",
        amount,
      );
  }

  updateCheckoutButton(threshold) {
    if (this.addon) {
      if (this.currentPoints < threshold) {
        this.nextButton.querySelector(".label").style.display = "none";
        this.nextButton.querySelector(".points").style.display = "block";
      }
      else {
        this.nextButton.querySelector(".label").style.display = "block";
        this.nextButton.querySelector(".points").style.display = "none";
      }
      return;
    } // always green
    if (this.currentPoints < threshold) {
      this.nextButton.classList.add("not-full");
      this.progressBar.style.display = "block";
      this.nextButton.querySelector(".label").style.display = "none";
      this.nextButton.querySelector(".points").style.display = "block";
      this.headerPointsCounter.querySelector('svg').classList.remove('full')
    } else {
      this.nextButton.classList.remove("not-full");
      this.progressBar.style.display = "none";
      this.nextButton.querySelector(".label").style.display = "block";
      this.nextButton.querySelector(".points").style.display = "none";
      this.headerPointsCounter.querySelector('svg').classList.add('full')
    }

    if ((this.currentPoints - this.maxPoints) < this.overflowPoints) {
      this.overflowButton.classList.add("not-full");
      this.overflowProgressBar.style.display = "block";
      this.overflowButton.querySelector(".points").style.display = "block";
      this.headerPointsCounter.querySelector('svg').classList.remove('full')
    } else {
      this.overflowButton.classList.remove("not-full");
      this.overflowProgressBar.style.display = "block";
      this.overflowButton.querySelector(".points").style.display = "block";
      this.headerPointsCounter.querySelector('svg').classList.add('full')
    }
  }

  submit(event) {
    if (this.submitTriggered) return;
    // check the points limits or minimum order value
    if (!this.addon && this.currentPoints < this.maxPoints) {
      // minimum number of points not used
      event.stopPropagation();
      this.showToolTip(false);
      return;
    } else if (this.currentPoints > this.maxOverflowPoints) {
      // points have been exceeded
      event.stopPropagation();
      this.showToolTip(true);
      return;
    }

    this.submitTriggered = true;
    this.nextButton.getElementsByClassName("loading")[0].style.display = "block";

    // consolidate the selected products into a simplified set
    let selected_products = {};
    for (const key in this.boxedProducts) {
      if (key.endsWith('promo')) continue;
      selected_products[key] = this.boxedProducts[key]["quantity"];
    }

    // append selected products as a hidden input in the buildForm
    let e = document.createElement("input");
    e.type = "hidden";
    e.name = "selected_products";
    e.value = JSON.stringify(selected_products);
    this.buildForm.appendChild(e);

    // POST buildForm
    this.buildForm.submit();
  }

  getPointsFormatted(product) {
    if (this.addon) return "";
    let points = product.quantity * (product.pointValue / this.pointScale);
    let innerHTML = points + " point";
    if (points != 1) innerHTML += 's';
    return innerHTML;
  }

  addBoxItem(product, quantity=1, promo=false) {
    // html representing a product and it's quantity in the user-built box
    let id = product.id;
    if (promo) id += "promo"
    let boxItem = `<div data-id="${id}" class="box-info-product">`;

    // combo button (similar to checkout/new_design/include/add_to_box_button.html)
    boxItem += `<div class="add-to-box-button in-cart">`;
    boxItem += `<div data-id="${id}" class="add-to-box standalone">`;
    if (promo)
      boxItem += '<div>PROMO</div>';
    else {
      boxItem += `<svg onclick="checkoutBuild.removeFromBox(event, '${id}')" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="remove-from-cart"><path fill-rule="evenodd" clip-rule="evenodd" fill="white" d="M4.25 12C4.25 11.4477 4.69772 11 5.25 11H19.25C19.8023 11 20.25 11.4477 20.25 12C20.25 12.5523 19.8023 13 19.25 13H5.25C4.69772 13 4.25 12.5523 4.25 12Z"/></svg>`;
      boxItem += '<div></div>';
      boxItem += `<svg onclick="checkoutBuild.addToBox(event, '${id}')" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="add-to-cart"><path fill-rule="evenodd" clip-rule="evenodd" fill="white" d="M12.0313 4C12.5836 4.00071 13.0307 4.449 13.03 5.00129L13.0223 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H13.0197L13.012 19.0013C13.0113 19.5536 12.563 20.0007 12.0107 20C11.4584 19.9993 11.0113 19.551 11.012 18.9987L11.0197 13H5C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11H11.0223L11.03 4.99871C11.0307 4.44643 11.479 3.99929 12.0313 4Z"/></svg>`;
    }
    boxItem += '</div></div>';

    // name
    boxItem += `<div class="name" onclick="checkoutBuild.openProductInfo('${id}')">${product.name}</div>`;

    // points
    boxItem += '<span class="points">';
    boxItem += promo ? TruTranslations['free'].toUpperCase() : this.getPointsFormatted(product);
    boxItem += "</span></div>";

    // create element and append it to the View Box modal
    const e = document.createElement('div');
    e.innerHTML = boxItem;
    this.boxContentElement.append(e);
    return {
      'element': e,
      'id': id,
      'quantity': quantity,
      'price': product.price,
      'summation': product.summation,
      'pointValue': product.pointValue
    };
  }
  /* box-content _end_ */

  setProduct(product) {
    this.products.push(product);
  }

  validateProducts() {
    this.updateElements();
    let p, remainingPoints = this.maxOverflowPoints - this.currentPoints;
    for (p of this.products) p.updateInfo(remainingPoints);
  }

  showMobileFilter() {
    if(window.innerWidth > 770){  // todo: hate this some more
      return;
    }
    document.querySelector(".build__filter").classList.toggle("active");
  }

  getProduct(id) {
    return this.products.find(p => p.id === id);
  }

  addBonusProduct(id, summation, imgUrl, name, quantity) {
    let product = new Product(this, null, id + "promo", "0", summation, "0", imgUrl, name);
    product.quantity = quantity;
    this.boxedProducts[product.id] = {
      name: name,
      pointValue: 0,
      summation: summation,
      quantity: quantity,
      element: this.addBoxItem(product, quantity, true),
      price: 0,
    };
  }

  addSelectedProduct(id, pointValue, summation, price, imgUrl, name, quantity) {
    // get product (or add it in case it's an invisible product)
    let product = this.getProduct(id);
    if (!product)
      product = new Product(this, null, id, pointValue, summation, price, imgUrl, name);

    // validate that we don't go over the maximum amount
    let new_total_points = this.currentPoints + product.pointValue * quantity;
    if (new_total_points > this.maxOverflowPoints) return;

    // have the addition take effect on the page
    product.quantity = product.quantity + quantity;
    if (this.boxedProducts[product.id]) {
      this.boxedProducts[product.id].quantity = product.quantity;
    } else {
      this.boxedProducts[product.id] = {
        name: name,
        pointValue: pointValue,
        summation: summation,
        quantity: product.quantity,
        element: this.addBoxItem(product, quantity),
        price: parseFloat(price.replace(",", ".")),
      };
    }
    this.currentPoints = new_total_points;
  }

  openProductInfo(id) {
    document.getElementById("pi_" + id).style.display = 'block';
    document.body.style.overflow = 'hidden';
  }
}

export class Product {

  constructor(CheckoutBuild, container, id, pointValue, summation, price, imgUrl, name) {
    this.CheckoutBuild = CheckoutBuild;
    this.container = container;
    this.quantity = 0;

    // gather data from button
    if (container) {
      let button = this.container.getElementsByClassName('add-to-box')[0];
      this.id = button.dataset.id;
      this.pointValue = button.dataset.pointValue;
      this.summation = button.dataset.summation;
      this.price = button.dataset.price;
      this.imgUrl = button.dataset.imgUrl;
      this.name = button.dataset.name;
    } else {
      this.id = id;
      this.pointValue = pointValue;
      this.summation = summation;
      this.price = price;
      this.imgUrl = imgUrl;
      this.name = name;
    }
    this.CheckoutBuild.setProduct(this);
  }

  updateInfo(remainingPoints) {
    let button, buttonText;
    let canFit = this.pointValue <= remainingPoints;
    for (button of document.querySelectorAll("[data-id='" + this.id + "'].add-to-box")) {
      if (this.container) {  // visible, non-bonus products only
        if (this.quantity) this.container.classList.add("in-cart");
        else this.container.classList.remove("in-cart");
      }

      // update the button's text
      buttonText = button.getElementsByTagName("span")[0];
      if (buttonText)
        buttonText.innerHTML = this.quantity ? this.quantity + ' ' + TruTranslations['_added'] : TruTranslations['add'];
      buttonText = button.getElementsByTagName("div")[0];
      if (buttonText)
        buttonText.innerHTML = this.quantity;

      // show/hide the + button
      button.getElementsByClassName("add-to-cart")[0].style.visibility = this.container && canFit ? null : "hidden";
    }
  }
}
